import {
  put,
  all,
  takeLatest,
  takeLeading,
  call,
  select,
} from "redux-saga/effects";
import environment from "../../../config/environment";
import {
  normalizeData,
  setNormalizedData,
} from "../../../Redux/Actions/normalizrActions";
import { paymentSchema } from "../../../Redux/Schemas/paymentSchema";
import { getConfigs, post } from "../../../services/httpService";
import {
  transactionPaymentActionFailure,
  transactionPaymentActionSuccess,
  transactionPaymentCreateFailure,
  transactionPaymentCreateSuccess,
  transactionRequestActionFailure,
  transactionRequestActionSuccess,
  TRANSACTION_PAYMENT_ACTION_REQUEST,
  TRANSACTION_PAYMENT_CREATE_REQUEST,
  TRANSACTION_REQUEST_ACTION_REQUEST,
} from "./paymentActions";
import { getSupplierSettings } from "../../../Redux/Selectors/appConfigSelector";
import { PAYMENT_METHOD_LABELS } from "../PaymentMethods";
import { transactionStatus } from "../../TransactionPage/helpers";

function* handleTransactionPaymentCreate(action) {
  try {
    const {
      payload: {
        provider,
        customProviderId,
        amount,
        currency,
        transactionId,
        autoConfirm,
      },
    } = action;
    const token = yield call(getConfigs);
    const supplierSettings = yield select(getSupplierSettings);
    const response = yield call(
      post,
      `${environment.api.apiBaseUrl}/api/payments`,
      {
        provider,
        customProviderId,
        amount,
        currency,
        transactionId,
      },
      token
    );
    if (response.status === 1) {
      yield put(normalizeData(response.data, paymentSchema));
      yield put(transactionPaymentCreateSuccess(response.data._id));
      if (
        provider === PAYMENT_METHOD_LABELS.wireTransfer ||
        provider === PAYMENT_METHOD_LABELS.shopCash ||
        provider === PAYMENT_METHOD_LABELS.westernUnion ||
        provider === PAYMENT_METHOD_LABELS.customPayment
      ) {
        const action = supplierSettings?.autoAcceptTransactions
          ? "accept"
          : "request";
        if (!autoConfirm) {
          yield call(handleTransactionAction, transactionId, action);
        }
      }
    } else {
      yield put(transactionPaymentCreateFailure(response.data.error));
    }
  } catch (err) {
    yield put(transactionPaymentCreateFailure(err));
  }
}

function* handleTransactionPaymentAction(action) {
  const {
    payload: { paymentId, action: paymentAction, actionParams = {} },
  } = action;
  try {
    const token = yield call(getConfigs);
    const response = yield call(
      post,
      `${environment.api.apiBaseUrl}/api/payments/${paymentId}/action`,
      {
        action: paymentAction,
        actionParams,
      },
      token
    );
    if (response.status === 1) {
      yield put(normalizeData(response.data, paymentSchema));
      yield put(transactionPaymentActionSuccess(paymentAction));
    } else {
      yield put(
        transactionPaymentActionFailure(paymentAction, response.data.error)
      );
    }
  } catch (err) {
    yield put(transactionPaymentActionFailure(paymentAction, err));
  }
}

function* handleTransactionAction(transactionId, actionType) {
  try {
    const token = yield call(getConfigs);
    yield call(
      post,
      `${environment.api.apiBaseUrl}/api/transaction/${transactionId}/action/${actionType}`,
      {},
      token
    );
  } catch (err) {
    console.log(err);
  }
}

export function* handleTransactionRequestAction(action) {
  const {
    payload: { transactionId, action: actionType },
  } = action;
  try {
    const token = yield call(getConfigs);
    const response = yield call(
      post,
      `${environment.api.apiBaseUrl}/api/transaction/${transactionId}/action/${actionType}`,
      {},
      token
    );
    // El backend responde status 1 con un texto ante una acción desconocida
    if (response?.status === 1 && response.data?._id) {
      // Actualiza el estado en el store para que volver a la pantalla de pago
      // no solicite la reserva otra vez
      yield put(
        setNormalizedData({
          entities: {
            transactions: {
              [transactionId]: {
                status:
                  actionType === "accept"
                    ? transactionStatus.ACCEPTED
                    : transactionStatus.PENDING_APPROVAL,
              },
            },
          },
        })
      );
      yield put(transactionRequestActionSuccess());
    } else {
      yield put(transactionRequestActionFailure(response?.data));
    }
  } catch (err) {
    yield put(transactionRequestActionFailure(err));
  }
}

export default function* transactionPaymentSaga() {
  yield all([
    takeLatest(
      TRANSACTION_PAYMENT_CREATE_REQUEST,
      handleTransactionPaymentCreate
    ),
    takeLatest(
      TRANSACTION_PAYMENT_ACTION_REQUEST,
      handleTransactionPaymentAction
    ),
    // takeLeading: un segundo dispatch no debe repetir el POST
    takeLeading(
      TRANSACTION_REQUEST_ACTION_REQUEST,
      handleTransactionRequestAction
    ),
  ]);
}
